import React from "react"
import styled, { useTheme } from "styled-components"
import { theme } from "@/common/Mixin"

import Introduction, { IntroductionProps } from "../Introduction"
import ProductHeading from "../_UI/ProductHeading"
import CustomerCard, { CustomerCardProps } from "./CustomerCard"
import { useMediaQuery } from "@mui/material"

const Fade = require("react-reveal/Fade")

interface StoryCard extends IntroductionProps {
  customerCard: CustomerCardProps
}

export interface SuccessStoryProps {
  items: StoryCard[]
  title?: string
  slogan?: string
}

export default function SuccessStory({
  items,
  title,
  slogan
}: SuccessStoryProps) {
  const theme = useTheme()
  const isMobile = useMediaQuery(`(${theme.lg})`)
  return (
    <Wrapper className="kg-wrapper">
      {title && <ProductHeading className="title" primary content={title} />}
      {slogan && (
        <Fade bottom>
          <ProductHeading as="h2" content={slogan} />
        </Fade>
      )}
      <ContentWrapper>
        {items.map(({ customerCard, ...props }, index) => (
          <ItemWrapper key={`${props.title}_${index}`}>
            <Introduction
              {...props}
              comp1Style={{ padding: isMobile ? "15px 30px" : "30px 60px" }}
              comp2={isMobile ? null : <CustomerCard {...customerCard} />}
              style={{ gridTemplateColumns: "1.6fr 1fr" }}
            />
          </ItemWrapper>
        ))}
      </ContentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`

const ContentWrapper = styled.div`
  display: flex;
  padding-top: 5vh;
  padding-bottom: 5vh;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-x: auto;

  @media (${theme.lg}) {
    flex-direction: column;
    width: 100%;
    overflow-x: hidden;
    gap: 48px;
  }
`

const ItemWrapper = styled.div`
  width: 100%;
  min-width: 500px;
  max-width: 1200px;
  border-radius: 20px;
  overflow: hidden;
  background-color: ${theme.color.secondary};
  @media (${theme.lg}) {
    min-width: 0px;
    width: 100%;
  }
`
